import styled, { css } from 'styled-components';

interface InputProps {
  isErrored: boolean;
}

export const BackgroundContainerModal = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: var(--background-modal);
  z-index: 1;
  display: flex;
  justify-content: center;
  padding: 5rem 0 0;
  color: var(--text-body);

  > div {
    display: flex;
    flex-direction: column;
    max-height: 465px;
    width: 90%;
    background-color: var(--white);
    overflow-y: auto;
    z-index: 2;
  }
`;

export const HeaderModal = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 2px solid var(--black-light);

  > p {
    padding: 1rem;
    font-weight: 700;
  }

  > svg {
    margin-right: 1rem;
    cursor: pointer;
  }
`;

export const ContentModal = styled.div`
  padding: 1rem;
  height: 100%;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  height: 100%;
`;

export const FormContent = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 0 1rem;

  > div {
    width: 45%;
  }
`;

export const ContainerButton = styled.div`
  margin-top: 2rem;
  padding: 0 1rem;
  width: 100%;
  max-width: 210px;
`;

export const InputWithMask = styled.div<InputProps>`
  padding: 5px;
  width: 100%;
  display: flex;
  align-items: center;
  border-bottom: 2px solid var(--text-title);
  color: var(--text-body);
  margin-top: 2rem;

  ${(props) =>
    props.isErrored &&
    css`
      border-color: var(--error);
    `}

  input {
    color: var(--text-title);
    flex: 1;
    background: transparent;

    &::placeholder {
      color: var(--text-body);
    }
  }

  > p {
    height: 20px;
    margin: 10px 0 0;
    font-size: 0.75rem;
    color: var(--error);
  }
`;

export const SectionAlternatives = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 2rem;

  p {
    font-size: 1rem;
    display: flex;
    align-items: center;
    margin-bottom: 1rem;

    svg {
      margin-left: 16px;
      font-size: 1.25rem;
      color: var(--primary);
      cursor: pointer;
    }
  }
`;

export const ContainerOption = styled.div`
  display: flex;
  align-items: center;

  & + div {
    margin-top: 0.5rem;
  }

  input:nth-child(1) {
    flex: 1;
  }

  input:nth-child(2) {
    width: 55px;
    padding: 0.5rem;
  }

  input {
    border-radius: 10px;
    padding: 0.5rem 1rem;
    width: 100%;
    border: 1px solid #000;

    & + input {
      margin-left: 1rem;
    }
  }

  svg {
    font-size: 1.5rem;
    margin-left: 1rem;
    color: var(--error);
    cursor: pointer;
  }
`;
